import { render } from "./ApplicantHistoryCard.vue?vue&type=template&id=4d06c434&scoped=true"
import script from "./ApplicantHistoryCard.vue?vue&type=script&lang=js"
export * from "./ApplicantHistoryCard.vue?vue&type=script&lang=js"

import "./ApplicantHistoryCard.vue?vue&type=style&index=0&id=4d06c434&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d06c434"]])

export default __exports__